import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgObjectDetection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.084 2.543 C 6.347 2.742,5.781 3.394,5.681 4.160 C 5.629 4.565,5.629 18.235,5.681 18.640 C 5.783 19.422,6.346 20.062,7.108 20.260 C 7.451 20.350,15.349 20.350,15.692 20.260 C 16.454 20.062,17.017 19.422,17.119 18.640 C 17.171 18.235,17.171 4.565,17.119 4.160 C 17.018 3.385,16.450 2.737,15.699 2.541 C 15.355 2.452,7.417 2.454,7.084 2.543 M15.521 3.834 C 15.597 3.875,15.700 3.967,15.750 4.040 C 15.830 4.157,15.840 4.221,15.840 4.606 L 15.840 5.040 11.400 5.040 L 6.960 5.040 6.960 4.606 C 6.960 4.221,6.970 4.156,7.051 4.036 C 7.247 3.742,6.960 3.760,11.401 3.760 C 15.198 3.760,15.388 3.763,15.521 3.834 M15.840 11.420 L 15.840 16.520 11.400 16.520 L 6.960 16.520 6.960 11.420 L 6.960 6.320 11.400 6.320 L 15.840 6.320 15.840 11.420 M15.840 18.214 C 15.840 18.578,15.829 18.645,15.749 18.764 C 15.553 19.058,15.840 19.040,11.400 19.040 C 6.960 19.040,7.247 19.058,7.051 18.764 C 6.971 18.645,6.960 18.578,6.960 18.214 L 6.960 17.800 11.400 17.800 L 15.840 17.800 15.840 18.214 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgObjectDetection;
